import {
    INITIAL_STATE,
    setRange,
    setHorizon,
    setCollapse,
    setDisplay,
    setGroupBy,
    setTeamDashboardId,
} from '../core'

import {
    SET_DASHBOARD_RANGE,
    SET_DASHBOARD_HORIZON,
    SET_DASHBOARD_COLLAPSE,
    SET_DASHBOARD_DISPLAY,
    SET_DASHBOARD_GROUP_BY,
    RECEIVE_TEAM_DASHBOARD,
} from '../action_creators'

function viewport(state=INITIAL_STATE.viewport, action) {
    switch (action.type) {
        case RECEIVE_TEAM_DASHBOARD: {
            return setTeamDashboardId(state, action.teamId)
        }
        case SET_DASHBOARD_RANGE:
            return setRange(state, action.range)
        case SET_DASHBOARD_HORIZON:
            return setHorizon(state, action.horizon)
        case SET_DASHBOARD_COLLAPSE:
            return setCollapse(state, action.collapse)
        case SET_DASHBOARD_DISPLAY:
            return setDisplay(state, action.display)
        case SET_DASHBOARD_GROUP_BY:
            return setGroupBy(state, action.groupBy)
        default:
            return state
    }
}

export default viewport


// WEBPACK FOOTER //
// ./src/redux/reducers/viewport_reducer.js